import type { ReactNode} from 'react';
import React, {useState, useCallback} from 'react'
import classNames from 'classnames'
import Icon from './Icon'
import icons from '../../markons/markons'
import ErrorBoundary from './ErrorBoundary'
import {getLocalStorage, setLocalStorage} from '../kb'

type Props = {
    id?: string
    storageKey?: string;
    title: string;
    className?: string;
    width?: string;
    noScroll?: boolean;
    children?: ReactNode
};

const ContentSection: React.FC<Props> = ({
    id,
    storageKey,
    title,
    className,
    width,
    noScroll,
    children
}) => {
    const [collapsed, setCollapsed] = useState<boolean>(() => {
        return storageKey ? getLocalStorage(`collapse.section.${storageKey}`) || false : false
    })

    const toggleCollapse = useCallback(
        (ev: React.MouseEvent) => {
            ev.preventDefault()
            const newState = !collapsed
            setCollapsed(newState)
            if(storageKey) {
                setLocalStorage(`collapse.section.${storageKey}`, newState)
            }
        },
        [collapsed, storageKey]
    )

    return (
        <div id={id}
            className={classNames('content-section', {
                collapsed,
                'no-print': collapsed
            }, className)}
            style={{maxWidth: width}}
        >
            <div className="section-header-bar">
                <h3>{title}</h3>
                {storageKey && (
                    <a
                        onClick={toggleCollapse}
                        className="collapse-section-button no-print"
                    >
                        <Icon name={collapsed ? icons.faPlusSquareO : icons.faMinusSquareO} />
                    </a>
                )}
            </div>
            {!collapsed && (
                <div className={classNames("section-content", {'no-scroll': noScroll})}>
                    <ErrorBoundary>
                        {children}
                    </ErrorBoundary>
                </div>
            )}
        </div>
    )
}

export default ContentSection
